"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _checkboxInputModule = _interopRequireDefault(require("./checkboxInput.module.css"));

var _themeModule = _interopRequireDefault(require("../../../styles/theme.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _loader = _interopRequireDefault(require("../loader/loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckboxInput = function CheckboxInput(props) {
  var id = props.id,
      label = props.label,
      name = props.name,
      checked = props.checked,
      onChange = props.onChange,
      disabled = props.disabled,
      onBlur = props.onBlur,
      required = props.required,
      isLoading = props.isLoading,
      _props$checkboxInputT = props.checkboxInputTestId,
      checkboxInputTestId = _props$checkboxInputT === void 0 ? 'checkbox-input' : _props$checkboxInputT,
      _props$checkboxInputV = props.checkboxInputValueTestId,
      checkboxInputValueTestId = _props$checkboxInputV === void 0 ? 'checkbox-input-value' : _props$checkboxInputV,
      _props$checkboxInputL = props.checkboxInputLabelTestId,
      checkboxInputLabelTestId = _props$checkboxInputL === void 0 ? 'checkbox-input-label' : _props$checkboxInputL;

  if (isLoading) {
    return _react.default.createElement(_loader.default, null);
  } else {
    return _react.default.createElement("div", {
      id: id ? id : null,
      className: (0, _classnames.default)(_themeModule.default.arag, _checkboxInputModule.default["checkbox"]),
      "data-testid": checkboxInputTestId
    }, _react.default.createElement("label", {
      id: id ? "".concat(id, "_label") : null
    }, _react.default.createElement("input", {
      id: "".concat(id, "_input"),
      disabled: disabled,
      type: "checkbox",
      name: name,
      checked: checked,
      onChange: onChange,
      onBlur: onBlur,
      required: required,
      "data-testid": checkboxInputValueTestId
    }), _react.default.createElement("span", {
      id: id ? "".concat(id, "_label_name") : null,
      "data-testid": checkboxInputLabelTestId
    }, label)));
  }
};

CheckboxInput.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** String text of the label of the checkbox */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** The name attribute of the input */
  name: _propTypes.default.string.isRequired,

  /** Boolean indicating if the checkbox is checked or not */
  checked: _propTypes.default.bool.isRequired,

  /** Callback fired on ckeckbox click with the vent object available. eg: (evt) => {} */
  onChange: _propTypes.default.func.isRequired,

  /** Boolean indicating if the input is disabled or not */
  disabled: _propTypes.default.bool,

  /** Callback invoked on blur. An event argument will be available. eg: (evt) => {} */
  onBlur: _propTypes.default.func,

  /** Boolean indicating if the component is required  */
  required: _propTypes.default.bool,

  /** Boolean indicating if the component is loading  */
  isLoading: _propTypes.default.bool,

  /** Test ID for checkbox input*/
  checkboxInputTestId: _propTypes.default.string,

  /** Test ID for checkbox label*/
  checkboxInputLabelTestId: _propTypes.default.string
};
var _default = CheckboxInput;
exports.default = _default;